import React from 'react';
import { Helmet } from 'react-helmet';
import { BrandContext } from '@zg-rentals/multibrand-ui/lib/BrandContext';

import withContext from '../../../../shared/utils/withContext';
import { logError } from '@zg-rentals/log-error';

interface IHelmetContainerProps {
  title: Record<string, string>;
  description?: Record<string, string>;
  scripts?: Array<{
    type?: string;
    src?: string;
    async?: boolean;
    defer?: boolean;
    innerHTML?: string;
  }>;
  brandContext: BrandContext;
}

class HelmetContainer extends React.Component<IHelmetContainerProps> {
  static defaultProps = {
    description: undefined,
    scripts: [],
  };

  // static propTypes = {
  //   title: PropTypes.object.isRequired,
  //   description: PropTypes.object,
  // };

  getTitle = (): string | null => {
    const {
      title,
      brandContext: { brand },
    } = this.props;

    if (!title || !brand) {
      logError({
        error: new Error(`Could not match brand: ${brand} to title map: ${JSON.stringify(title)}.`),
      });
      return null;
    }

    return title[brand];
  };

  getDescription = (): string | null => {
    const {
      description,
      brandContext: { brand },
    } = this.props;

    if (!description || !brand) {
      return null;
    }

    return description[brand];
  };

  render(): React.ReactNode {
    const title = this.getTitle();
    const description = this.getDescription();
    const { scripts } = this.props;

    return (
      <Helmet>
        {title && <title>{title}</title>}
        {description && <meta name="description" content={description} />}
        {scripts?.map((script, index) =>
          script.innerHTML ? (
            <script
              key={index}
              type={script.type || 'text/javascript'}
              {...(script.async ? { async: true } : {})}
              {...(script.defer ? { defer: true } : {})}
            >
              {script.innerHTML}
            </script>
          ) : (
            <script /* oxlint-disable-line next/no-sync-scripts -- not a Next.js app (no next dependency, custom SSR server) */
              key={index}
              type={script.type || 'text/javascript'}
              src={script.src}
              {...(script.async ? { async: true } : {})}
              {...(script.defer ? { defer: true } : {})}
            />
          ),
        )}
      </Helmet>
    );
  }
}

export default withContext(HelmetContainer, BrandContext, 'brandContext');
